import { render, staticRenderFns } from "./FeedbackComponent.vue?vue&type=template&id=2e97e6d5"
import script from "./FeedbackComponent.vue?vue&type=script&lang=js"
export * from "./FeedbackComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports